import React, { useEffect, useState } from "react";
import {useNavigate, useParams} from "react-router-dom";
import { apiRequestWithAuth } from "../../utils/api";
import { Table, TableBody, TableCell, TableHeader, TableRow } from "../../components/ui/table";

interface Lesson {
    id: number;
    title: string;
    shortDescription: string;
    orderNo: number;
}

const LessonList = () => {
    const { courseId } = useParams(); // lấy courseId từ URL
    const navigate = useNavigate();
    const [lessons, setLessons] = useState([]);

    useEffect(() => {
        fetchLessons();
    }, [courseId]);

    const fetchLessons = async () => {
        try {
            const res = await apiRequestWithAuth(`/course/${courseId}/lesson`, "GET");
            setLessons(res.result || []);
        } catch (error) {
            console.error("Failed to fetch lessons:", error);
        }
    };

    const handleAddLesson = () => {
        navigate(`/course/${courseId}/lesson/create`);
    };

    return (
        <div className="">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6">Danh sách bài học</h2>

            <button
                className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-lg shadow-md transition duration-300"
                onClick={handleAddLesson}
            >
                + Thêm bài học
            </button>

            <div className="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-white/[0.05] dark:bg-white/[0.03] mt-4">
                <div className="max-w-full overflow-x-auto">
                    <div className="min-w-[800px]">
                        <Table>
                            <TableHeader className="border-b border-gray-100 dark:border-white/[0.05]">
                                <TableRow>
                                    <TableCell isHeader className=" px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Tên bài học</TableCell>
                                    <TableCell isHeader className="px-5 py-3 font-medium text-gray-400 text-start text-theme-xs dark:text-gray-400">Mô tả</TableCell>
                                    <TableCell isHeader className="px-5 py-3 font-medium text-gray-400 text-start text-theme-xs dark:text-gray-400">Thứ tự</TableCell>
                                    <TableCell isHeader className="px-5 py-3 font-medium text-gray-400 text-start text-theme-xs dark:text-gray-400">Hành động</TableCell>
                                </TableRow>
                            </TableHeader>

                            <TableBody className="divide-y divide-gray-100 dark:divide-white/[0.05]">
                                {lessons.map((lesson: any) => (
                                    <TableRow key={lesson.id}>
                                        <TableCell className="px-5 py-4 text-start text-theme-sm dark:text-white/90">
                                            <span className="block font-medium text-gray-800 dark:text-white/90">{lesson.title}</span>
                                        </TableCell>
                                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-white/90">{lesson.shortDescription}</TableCell>
                                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-white/90">{lesson.orderNo}</TableCell>
                                        <TableCell className="px-4 py-3 text-start text-theme-sm dark:text-white/90">
                                            <button
                                                className="bg-blue-500 hover:bg-blue-600 text-white text-sm py-1 px-3 rounded-lg mr-2"
                                                onClick={() => navigate(`/lessons/${lesson.id}/edit`)}
                                            >
                                                Chỉnh sửa
                                            </button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LessonList;
